// src/utils/auth.ts
interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

const TOKEN_KEY = "admin_auth_tokens";

export const authUtils = {
  // 토큰 저장
  setTokens: (tokens: AuthTokens): void => {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
  },

  // 토큰 가져오기
  getTokens: (): AuthTokens | null => {
    const tokens = localStorage.getItem(TOKEN_KEY);
    return tokens ? JSON.parse(tokens) : null;
  },

  // Access Token 가져오기
  getAccessToken: (): string | null => {
    const tokens = authUtils.getTokens();
    return tokens?.accessToken || null;
  },

  // Refresh Token 가져오기
  getRefreshToken: (): string | null => {
    const tokens = authUtils.getTokens();
    return tokens?.refreshToken || null;
  },

  // 토큰 삭제
  clearTokens: (): void => {
    localStorage.removeItem(TOKEN_KEY);
  },

  // 로그인 상태 확인
  isAuthenticated: (): boolean => {
    const accessToken = authUtils.getAccessToken();
    if (!accessToken) return false;

    try {
      // JWT 토큰의 만료 시간 확인
      const payload = JSON.parse(atob(accessToken.split(".")[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp > currentTime;
    } catch {
      return false;
    }
  },
};

export default authUtils;

